import {Component, Input, OnDestroy} from '@angular/core';
import {AbstractControl, FormControlStatus} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss'],
  standalone: false,
})
export class GenericErrorComponent implements OnDestroy {
  @Input() control: AbstractControl | null = null;
  state: FormControlStatus | null = null;

  private subscriptions: Subscription[] = [];

  initStateListener(): void {
    if (this.control) {
      this.subscriptions.push(
        this.control.statusChanges.subscribe(status => {
          this.state = status;
        }),
      );
    } else {
      console.warn('No control found');
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  getErrorMessage(): any {
    if (this.control) {
      if (this.control.invalid && (this.control.dirty || this.control.touched || this.state)) {
        if (this.control.hasError('required')) {
          return $localize`This field is required.`;
        }
        if (this.control.hasError('message')) {
          return this.control.getError('message');
        }
        if (this.control.hasError('noPwMatch')) {
          return $localize`The new password fields do not match.`;
        }
        if (this.control.hasError('invalidNumber')) {
          return $localize`Number is not valid`;
        }
        if (this.control.hasError('numberTooLong')) {
          return $localize`Phone number is too long`;
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
